// Horner's Rule: https://rosettacode.org/wiki/Horner%27s_rule_for_polynomial_evaluation
export const getPointFromPolynomial = (x: number, coefficients: readonly number[]) => {
  const degree = coefficients.length - 1;
  let total = 0;
  for (let i = degree; i >= 0; i -= 1) {
    total = x * total + coefficients[i];
  }
  return total;
};
